import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { GetUserRegisterSummaryResponse, TimeDurationEnum } from '@/models/dashboard.model';
import { getUserRegisterSummary } from '@/services/dashboard.service';
import { toastErrorMessage } from '@/utils/toasterMessage';
import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { ButtonGroup, Button } from 'rsuite';
import BarChart from './BarChart';


const RegisteredUsersBarChart = () => {
  const [registerSummaryBarChartData, setRegisterSummaryBarChartData] = useState<any>({labels:[], data:[]});
  const [registerSummaryDuration, setRegisterSummaryDuration] = useState<TimeDurationEnum>(TimeDurationEnum.Daily);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    fetchData();
  }, [registerSummaryDuration]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const result: BaseResponseModel<GetUserRegisterSummaryResponse> = 
        await getUserRegisterSummary({duration: registerSummaryDuration});
      if (result.success) {
        setRegisterSummaryBarChartData({
          labels: result.result.titles.reverse(),
          data: [
            {name: "Registered", data: result.result.userRegistered.reverse()},
          ]
        });
      }
    } catch (err) {
      const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
      toastErrorMessage(`Error in fetching user register summary: ${errorModel?.errorMessage}`);
    }
    finally {
      setLoading(false);
    }
  };
  
  return (
    <BarChart
      title="Customer Register Summary"
      actions={
        <ButtonGroup>
          <Button 
            onClick={() => setRegisterSummaryDuration(TimeDurationEnum.Daily)} 
            active={registerSummaryDuration == TimeDurationEnum.Daily}
          >Day</Button>
          <Button 
            onClick={() => setRegisterSummaryDuration(TimeDurationEnum.Weekly)} 
            active={registerSummaryDuration == TimeDurationEnum.Weekly}
          >Week</Button>
          <Button 
            onClick={() => setRegisterSummaryDuration(TimeDurationEnum.Monthly)} 
            active={registerSummaryDuration == TimeDurationEnum.Monthly}
          >Month</Button>
        </ButtonGroup>
      }
      data={registerSummaryBarChartData.data}
      type="bar"
      labels={registerSummaryBarChartData.labels}
      loading={loading}
      options={{
        zoom: {enabled: false},
        xaxis:{type: 'string'}
      }}
    />    
  );
};

export default RegisteredUsersBarChart;
